/* eslint-disable */
export default {
  dncAlert: 'This contact is on a Do Not Call list.',
} as const;

// @key: @#@"dncAlert"@#@ @source: @#@"This contact is on a Do Not Call list."@#@
